<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Manage User's Cart</h1>
        </div>
        <!-- <div class="flex has-margin-bottom-30">
          <div class="columns is-centered">
            <div class="column">
              <b-field>
                <b-autocomplete
                  placeholder="Select a title to add"
                  :data="filteredTitles"
                  field="title"
                  expanded
                  :open-on-focus="true"
                  @select="
                    value => {
                      if (value && value.id) {
                        selectedTitle = value.id
                      }
                    }
                  "
                >
                </b-autocomplete>
                <p class="control">
                  <b-button @click="addTitle(selectedTitle)" type="is-primary"
                    >Add</b-button
                  >
                </p>
              </b-field>
            </div>
          </div>
        </div> -->
        <div class="columns is-vcentered">
          <div class="column is-10 is-offset-1">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <div>
                  <b-field label="Select Collection">
                    <b-select
                      v-model="collection"
                      :expanded="true"
                      @input="
                        $router.push({
                          name: 'ManageCartByList',
                          params: {
                            id: $route.params.id,
                            collectionid: collection.id
                          }
                        })
                      "
                    >
                      <option
                        v-for="item in collections"
                        :key="item.id"
                        :value="item"
                        >{{ item.name }}</option
                      >
                    </b-select>
                  </b-field>
                </div>
                <ValidationObserver
                  v-if="collection"
                  ref="observer"
                  v-slot="{ passes }"
                >
                  <form @submit.prevent="passes(submit)">
                    <div>
                      <div
                        v-if="cartItems.length === 0"
                        class="has-text-centered"
                      >
                        No items in collection yet.
                      </div>
                      <div v-if="cartItems.length > 0">
                        <div
                          class="columns has-text-left has-text-weight-bold is-hidden-mobile"
                          style="border-bottom: 1px solid #eee;"
                        >
                          <div class="column is-2"></div>
                          <div class="column is-5">Title</div>
                          <div class="column is-2">Budget</div>
                          <div class="column is-1"></div>
                        </div>
                        <div
                          v-for="item in cartItems"
                          :key="item.id"
                          class="columns is-vcentered"
                        >
                          <div class="column is-2">
                            <router-link
                              :to="{
                                name: 'MediaDetail',
                                params: { id: item.media_id }
                              }"
                            >
                              <figure v-if="getTitleImage(item)" class="image">
                                <img :src="getTitleImage(item)" />
                              </figure>
                            </router-link>
                          </div>
                          <div class="has-padding-left-15 column is-5">
                            <router-link
                              :to="{
                                name: 'MediaDetail',
                                params: { id: item.media_id }
                              }"
                            >
                              <h3 class="subtitle">{{ item.title }}</h3>
                            </router-link>
                          </div>
                          <div class="has-padding-left-15 column is-2">
                            ${{ item.budget }}
                            <!-- <b-input
                              v-model="item.budget"
                              class="has-margin-right-5 has-margin-left-5"
                              type="number"
                              icon="currency-usd"
                              @input="update(item)"
                            /> -->
                          </div>
                          <!-- <div
                            class="has-padding-left-15 column is-1 is-hidden-desktop is-hidden-tablet"
                          >
                            <b-button
                              icon-left="close"
                              @click="confirmRemove(item)"
                              >Remove</b-button
                            >
                          </div> -->
                          <!-- <div
                            class="has-padding-left-15 column is-1 has-text-centered is-hidden-mobile"
                          >
                            <a href="" @click.prevent="confirmRemove(item)"
                              ><b-icon icon="close"></b-icon
                            ></a>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
    <b-modal
      :active.sync="showConfirmModal"
      trap-focus
      aria-role="dialog"
      aria-modal
      has-modal-card
      @close="showConfirmModal = false"
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirm?</p>
        </header>
        <section class="modal-card-body">
          Are you sure you want to remove this title?
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <button
            class="button"
            type="button"
            @click="showConfirmModal = false"
          >
            No
          </button>
          <button class="button is-primary" @click.prevent="remove()">
            Yes
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import CartApi from '@/api/cart'
import CollectionApi from '@/api/collections'
import Filters from '@/mixins/filters'
import Utils from '@/mixins/utils'
export default {
  name: 'Cart',
  components: {
    CardComponent
  },
  mixins: [Filters, Utils],
  metaInfo: {
    title: 'Manage Cart'
  },
  data() {
    return {
      initialized: false,
      loading: false,
      cartItems: [],
      showConfirmModal: false,
      item: {},
      selectedTitle: null,
      titles: [],
      collections: [],
      collection: null,
      collectionName: null
    }
  },
  computed: {
    filteredTitles() {
      if (this.cartItems.length > 0 && this.titles.length > 0) {
        let cartItemsMediaIds = this.cartItems.map(item => item.media_id)
        return this.titles.filter(item => !cartItemsMediaIds.includes(item.id))
      } else {
        return this.titles
      }
    }
  },
  watch: {
    $route() {
      if (this.$route.params.id) {
        this.collection = this.collections.find(
          item =>
            item.id.toString() === this.$route.params.collectionid.toString()
        )
        this.fetchItems()
      }
    }
  },
  async created() {
    this.collections = await CollectionApi.getAll(this.$route.params.id)
    if (this.$route.params.collectionid) {
      this.collection = this.collections.find(
        item => item.id.toString() === this.$route.params.collectionid
      )
      this.fetchItems()
    }
    this.initialized = true
  },
  methods: {
    async fetchItems() {
      this.cartItems = []
      let items = await CartApi.getByUserId(
        this.$route.params.id,
        this.$route.params.collectionid
      )
      items.forEach(item => {
        if (item.mediadata) {
          item.mediadata = JSON.parse(item.mediadata)
        }
      })
      this.cartItems = items
    },
    addTitle(titleId) {
      CartApi.adminAdd({
        userId: this.$route.params.id,
        mediaId: titleId,
        budget: 0
      })
        .then(() => {
          this.$buefy.toast.open({
            message: 'Title added successfully',
            position: 'is-top',
            type: 'is-success'
          })
          this.selectedTitle = null
          this.fetchCart()
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: 'Error adding to collection',
            position: 'is-top',
            type: 'is-danger'
          })
        })
    },
    getTitleImage(item) {
      return item.mediadata &&
        item.mediadata.titleImage &&
        item.mediadata.titleImage !== ''
        ? this.thumbnail(item.mediadata.titleImage)
        : null
    },
    async update(item) {
      await CartApi.update({
        cartItemId: item.id,
        mediaId: item.media_id,
        budget: item.budget
      })
    },
    confirmRemove(item) {
      this.showConfirmModal = true
      this.item = item
    },
    remove() {
      CartApi.remove({
        cartItemId: this.item.id
      })
        .then(() => {
          this.$buefy.toast.open({
            message: 'Title removed successfully!',
            position: 'is-top',
            type: 'is-success'
          })
          this.cartItems = this.cartItems.filter(
            item => item.id !== this.item.id
          )
          this.showConfirmModal = false
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Title removed deleting media',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    }
  }
}
</script>
